import i18n from "@/utils/i18n.util";

export default function useTranslation(namespaceArray?: string) {
  return i18n.useTranslation(namespaceArray);
}
